import React from 'react'

import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

import './not-found.css'

const NotFound = (props) => {
  const { t } = useTranslation()
  return (
    <div className="not-found-container1">
      <Helmet>
        <title>{t('notFound.title')}</title>
      </Helmet>
      <h3>{t('notFound.oops')}</h3>
      <div className="not-found-container2">
        <h1 className="not-found-text2">404</h1>
      </div>
      <div className="not-found-container3">
        <h2 className="not-found-text3">{t('notFound.message')}</h2>
      </div>
    </div>
  )
}

export default NotFound
